/** The badge on a project, card or workspace that belongs to another organization. */
export const SHARED_BADGE = 'Shared';

/** The heading of a group of such things, the landing section and the Organizations page. */
export const SHARED_GROUP = 'Shared with you';

/** The action that leaves another organization's workspace for the home one. */
export const BACK_TO_HOME = 'Back to your organization';

/** The line on a card that says who shared it: `Shared with you by <Organization name>`. */
export function sharedByText(organizationName: string): string {
  return `${SHARED_GROUP} by ${organizationName}`;
}
